module.exports = __webpack_public_path__ + "img/dante-inferno-logo.43d169ef.svg";